import styled, { css } from 'styled-components';

import Tooltip from '../../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border: 1px solid #b0bec5;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  color: #455a64;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
      color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: #2196f3;
      //border-color: #2196f3;
    `}

  ${props =>
    props.isField &&
    css`
      color: #78909c;
    `}

  input {
    display: flex;
    width: 100%;
    font-weight: 500;
    color: #333;
    cursor: pointer;

    &::placeholder {
      color: #90a4ae;
    }

    :focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }
  }
  datalist {
    position: absolute !important;
    background-color: white !important;
    border: 1px solid blue !important;
    border-radius: 0 0 5px 5px !important;
    border-top: none !important;
    width: 100% !important;
    padding: 5px !important;
    max-height: 10rem !important;
    overflow-y: auto !important;
  }

  option {
    background-color: white;
    padding: 4px;
    color: blue;
    margin-bottom: 1px;
    font-size: 18px;
    cursor: pointer;
  }

  option:hover,
  .active {
    background-color: lightblue;
  }

  svg {
    font-size: 30px;
    margin-right: 10px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
